import { useAuthStore } from '@/stores/authStore'

// Governance roles (qtz-risk internal/auth/roles.go).
export type Role =
  | 'policy_author'
  | 'security_owner'
  | 'auditor'
  | 'waiver_approver'
  | string

// expandRole maps a qtz-account org role (owner/admin/member) to the governance
// roles it grants — mirrors auth.ExpandRoles in the qtz-risk backend so the UI
// shows exactly what the backend will allow. Unknown tokens pass through (already
// governance roles).
function expandRole(r: string): string[] {
  switch (r.toLowerCase()) {
    case 'owner':
    case 'admin':
      return ['policy_author', 'security_owner', 'waiver_approver', 'auditor', 'framework_owner:*']
    case 'member':
      return ['auditor']
    default:
      return [r]
  }
}

export function useRoles(): string[] {
  const role = useAuthStore((s) => s.role)
  // role claim may be a single role or comma-separated list.
  return (role ?? '')
    .split(',')
    .map((r) => r.trim())
    .filter(Boolean)
    .flatMap(expandRole)
}

export function hasRole(roles: string[], required: Role | Role[]): boolean {
  const need = Array.isArray(required) ? required : [required]
  // framework_owner:* composite — match by prefix.
  return need.some((r) => roles.some((have) => have === r || have.startsWith(`${r}:`)))
}
